import { normalizeFields } from "@/forms/helpers";

export function createFilterModel(
  filterOptions: MedsSearchFilterOptions,
  searchParams: Record<string, string>,
) {
  const urlSearchParams = new URLSearchParams(searchParams as any);
  const params = Object.fromEntries(urlSearchParams.entries());

  const fields = {
    price: {
      placeholder: "meds.filter.price",
      options: filterOptions.price,
      value: filterOptions.price.find(
        ({ value }) => value === parseInt(params.price),
      )?.value,
      type: "select",
      disabled: filterOptions.price.length === 0,
    },
    kinds: {
      placeholder: "meds.filter.kind",
      options: filterOptions.kinds,
      value: params.kinds,
      type: "select",
      disabled: filterOptions.kinds.length === 0,
    },
    withoutPrescription: {
      label: "meds.filter.withoutPrescription",
      value: !!params.withoutPrescription,
      type: "checkbox",
    },
    forNurse: {
      label: "meds.filter.forNurse",
      value: !!params.forNurse,
      type: "checkbox",
    },
  };

  return normalizeFields(fields);
}
